import { useTheme } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import * as Device from 'react-device-detect';

import { useSession } from '@hooks';
import {
  Birthdate,
  Firstname,
  Lastname,
  Gender,
  Email,
  Language,
  Password,
  Address,
  DangerZone,
} from './components';
import Header from '../header';

interface UserSettingsDialogProps {
  handleCloseDialog: () => void;
  handleCloseDrawer: () => void;
}

export function UserSettingsDialog(props: Readonly<UserSettingsDialogProps>) {
  const { handleCloseDialog } = props;
  const theme = useTheme();
  const { user } = useSession();
  const { t } = useTranslation('account');

  if (!user) {
    return null;
  }

  return (
    <>
      <Header
        title={t('menu.user settings')}
        Icon={theme.icons.manageAccount}
        handleCloseDialog={handleCloseDialog}
      />
      <DialogContent
        sx={{
          pt: Device.isMobile ? 10 : 4,
          px: Device.isMobile ? 2 : 5,
          pb: 5,
        }}
      >
        <Stack spacing={5} divider={<Divider variant="middle" />}>
          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              {t('menu.preferences')}
            </Typography>
            <Language />
          </Stack>

          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              {t('menu.personal infos')}
            </Typography>
            <Firstname />
            <Lastname />
            <Gender />
            <Birthdate />
            <Address />
          </Stack>

          <Stack spacing={3}>
            <Typography variant="h6" fontWeight="bold">
              {t('menu.access')}
            </Typography>
            <Email />
            <Password />
            <Divider variant="middle" />
            <DangerZone {...props} />
          </Stack>
        </Stack>
      </DialogContent>
    </>
  );
}
